import { doGET, doPATCH, doPOST } from "../../utils/HttpUtils";
import { showError } from "../../services/toaster";

const BASE = "/payouts";

const handleResponse = (response: any, fallback: string) => {
  if (response.status >= 200 && response.status < 400) {
    return response.data?.data ?? response.data;
  }
  showError(response.message || fallback);
  return null;
};

export const payoutService = {
  fetchGrid: async (search = "") => {
    const query = search ? `?search=${encodeURIComponent(search)}` : "";
    const response = await doGET(`${BASE}/grid${query}`);
    return handleResponse(response, "Failed to fetch payout grid") ?? [];
  },

  fetchBillings: async (specialistId: string, year: number) => {
    const response = await doPOST(`${BASE}/billings`, {
      specialist_id: specialistId,
      year,
    });
    return handleResponse(response, "Failed to fetch billings") ?? [];
  },

  calculateYear: async (specialistId: string, year: number) => {
    const response = await doPOST(`${BASE}/billings/calculate-year`, {
      specialist_id: specialistId,
      year,
    });
    return handleResponse(response, "Failed to calculate billings");
  },

  createDisbursal: async (payload: any) => {
    const response = await doPOST(`${BASE}/disbursal`, payload);
    return handleResponse(response, "Failed to create disbursal");
  },

  fetchDisbursalHistory: async (specialistId: string) => {
    const response = await doPOST(`${BASE}/disbursal/history`, {
      specialist_id: specialistId,
    });
    return handleResponse(response, "Failed to fetch disbursal history") ?? [];
  },

  updateDisbursal: async (payload: any) => {
    const response = await doPATCH(`${BASE}/disbursal/update`, payload);
    return handleResponse(response, "Failed to update disbursal");
  },

  getInvoice: async (specialistId: string, month: number) => {
    const response = await doPOST(`${BASE}/billings/get-invoice`, {
      specialist_id: specialistId,
      month,
    });
    return handleResponse(response, "Failed to fetch invoice");
  },

  getReceipt: async (disbursalId: string) => {
    const response = await doPOST(`${BASE}/billings/get-receipt`, {
      disbursal_id: disbursalId,
    });
    return handleResponse(response, "Failed to fetch receipt");
  },
};
